import { SET_REPORT, SET_LOADING } from "../actions";
import { ReportsReducer, ReportRecordTypes } from "../types/reportTypes";

const TABLE_INITIAL_STATE = { records: [], loading: false };
export const REPORTS_REDUCER_INITIAL_STATE = {
  processed_ads_by_cluster: TABLE_INITIAL_STATE,
  processed_ads_by_partner: TABLE_INITIAL_STATE,
  fulfillment_completions_by_user: TABLE_INITIAL_STATE,
  ads_and_smbs: TABLE_INITIAL_STATE,
  total_ads: TABLE_INITIAL_STATE,
  percentage_of_origami_sites: TABLE_INITIAL_STATE,
  ads_over_90_days: TABLE_INITIAL_STATE,
  yoy_ads: TABLE_INITIAL_STATE,
  product_summary: TABLE_INITIAL_STATE,
  account_owner_summary: TABLE_INITIAL_STATE,
  xtd_by_group: TABLE_INITIAL_STATE,
  xtd_by_pub: TABLE_INITIAL_STATE,
  billed_origami_ads_wtd: TABLE_INITIAL_STATE,
  billed_origami_ads_lwtd: TABLE_INITIAL_STATE,
  billed_origami_ads_mtd: TABLE_INITIAL_STATE,
  billed_origami_ads_lmtd: TABLE_INITIAL_STATE,
  received_origami_ads_wtd: TABLE_INITIAL_STATE,
  received_origami_ads_lwtd: TABLE_INITIAL_STATE,
  received_origami_ads_mtd: TABLE_INITIAL_STATE,
  received_origami_ads_lmtd: TABLE_INITIAL_STATE,
  partners_sending_origami_ads: TABLE_INITIAL_STATE,
  average_origami_ads_per_partner: TABLE_INITIAL_STATE,
  processed_origami_ads_by_group: TABLE_INITIAL_STATE,
  started_origami_ads_by_publication: TABLE_INITIAL_STATE,
  billed_legacy_ads_wtd: TABLE_INITIAL_STATE,
  billed_legacy_ads_lwtd: TABLE_INITIAL_STATE,
  billed_legacy_ads_mtd: TABLE_INITIAL_STATE,
  billed_legacy_ads_lmtd: TABLE_INITIAL_STATE,
  received_legacy_ads_wtd: TABLE_INITIAL_STATE,
  received_legacy_ads_lwtd: TABLE_INITIAL_STATE,
  received_legacy_ads_mtd: TABLE_INITIAL_STATE,
  received_legacy_ads_lmtd: TABLE_INITIAL_STATE,
  partners_sending_legacy_ads: TABLE_INITIAL_STATE,
  average_legacy_ads_per_partner: TABLE_INITIAL_STATE,
  processed_legacy_ads_by_group: TABLE_INITIAL_STATE,
  started_legacy_ads_by_publication: TABLE_INITIAL_STATE,
  origami_ads_without_state_machine: TABLE_INITIAL_STATE,
  unfulfilled_ads_over_20_hours: TABLE_INITIAL_STATE,
  directory_ads_without_state_machine: TABLE_INITIAL_STATE,
  unfulfilled_directory_over_20_hours: TABLE_INITIAL_STATE,
  catch_all: TABLE_INITIAL_STATE,
  ads_with_pdf_conversion_failure: TABLE_INITIAL_STATE,
  ads_without_pdfs: TABLE_INITIAL_STATE,
  estimated_ads_tm: TABLE_INITIAL_STATE,
  mtd_ads_pct_chg_vs_ly: TABLE_INITIAL_STATE,
  mtd_ads_pct_chg_vs_lm: TABLE_INITIAL_STATE,
  estimated_smbs_tm: TABLE_INITIAL_STATE,
  mtd_smbs_pct_chg_vs_ly: TABLE_INITIAL_STATE,
  mtd_smbs_pct_chg_vs_lm: TABLE_INITIAL_STATE,
  ads_by_month_ty_vs_ly: TABLE_INITIAL_STATE,
  smbs_by_month_ty_vs_ly: TABLE_INITIAL_STATE,
  ads_by_week_yoy: TABLE_INITIAL_STATE,
  smbs_by_week_yoy: TABLE_INITIAL_STATE,
};

type ReportOptions =
  | "processed_ads_by_cluster"
  | "processed_ads_by_partner"
  | "fulfillment_completions_by_user"
  | "ads_and_smbs"
  | "total_ads"
  | "percentage_of_origami_sites"
  | "ads_over_90_days"
  | "yoy_ads"
  | "product_summary"
  | "account_owner_summary"
  | "xtd_by_group"
  | "xtd_by_pub"
  | "billed_origami_ads_wtd"
  | "billed_origami_ads_lwtd"
  | "billed_origami_ads_mtd"
  | "billed_origami_ads_lmtd"
  | "received_origami_ads_wtd"
  | "received_origami_ads_lwtd"
  | "received_origami_ads_mtd"
  | "received_origami_ads_lmtd"
  | "partners_sending_origami_ads"
  | "average_origami_ads_per_partner"
  | "processed_origami_ads_by_group"
  | "started_origami_ads_by_publication"
  | "billed_legacy_ads_wtd"
  | "billed_legacy_ads_lwtd"
  | "billed_legacy_ads_mtd"
  | "billed_legacy_ads_lmtd"
  | "received_legacy_ads_wtd"
  | "received_legacy_ads_lwtd"
  | "received_legacy_ads_mtd"
  | "received_legacy_ads_lmtd"
  | "partners_sending_legacy_ads"
  | "average_legacy_ads_per_partner"
  | "processed_legacy_ads_by_group"
  | "started_legacy_ads_by_publication"
  | "origami_ads_without_state_machine"
  | "unfulfilled_ads_over_20_hours"
  | "directory_ads_without_state_machine"
  | "unfulfilled_directory_over_20_hours"
  | "catch_all"
  | "ads_with_pdf_conversion_failure"
  | "ads_without_pdfs"
  | "estimated_ads_tm"
  | "mtd_ads_pct_chg_vs_ly"
  | "mtd_ads_pct_chg_vs_lm"
  | "estimated_smbs_tm"
  | "mtd_smbs_pct_chg_vs_ly"
  | "mtd_smbs_pct_chg_vs_lm"
  | "ads_by_month_ty_vs_ly"
  | "smbs_by_month_ty_vs_ly"
  | "ads_by_week_yoy"
  | "smbs_by_week_yoy";

type DataPayloadType = {
  value: boolean | Array<ReportRecordTypes>;
  target: ReportOptions;
};
type DataReducerProps = { type: string; payload: DataPayloadType };
type ReportType = { records: Array<ReportRecordTypes>; loading: boolean };
type NewStateType = { [Identifier: string]: ReportType };

export default (
  state: ReportsReducer = REPORTS_REDUCER_INITIAL_STATE,
  { type, payload }: DataReducerProps,
): ReportsReducer => {
  const newState: NewStateType = {};
  switch (type) {
    case SET_REPORT: {
      newState[payload.target] = {
        ...state[payload.target],
        records: payload.value as Array<ReportRecordTypes>,
      };
      return { ...state, ...newState };
    }
    case SET_LOADING: {
      newState[payload.target] = {
        ...state[payload.target],
        loading: payload.value as boolean,
      };
      return { ...state, ...newState };
    }
    default:
      return state;
  }
};
